import { VesselNotificationsService } from "../services/vessel-notifications-service";
import {
	AlarmPayload,
	AlarmTypes,
	BestPracticeRoutePayload,
	NotificationTypes,
	VoyNotification,
	WeatherAlarmNotificationData,
} from "../services/types/vessel-notifications-services.types";
import { AlarmEvents, VesselAlarmsModelBase } from "./vessel-alarms-model";
import { VesselAlertsModel,AlertType } from '../../src/models/vessel-alerts-model';
import { getAlarmDescription } from '../../src/utils/vessel-alarm-utils';
import { VoyageImoModel } from "./voyage-imo-model";
import { VoyageImoEventNames } from "./voyage-imo-model-impl";

const postponeDeadline = 1000 * 60 * 60 * 12; // 12 hours
const CACHE_TIMEOUT = 1000 * 60 * 5; // 5 minutes

export class VesselAlarmsModelImpl extends VesselAlarmsModelBase {
	constructor() {
		super();

		this.refreshAlarms();
		let intervalID: number;

		intervalID = setInterval(() => this.refreshAlarms(),CACHE_TIMEOUT); //refresh every 15 minutes 
        VoyageImoModel!.addEventListener(VoyageImoEventNames.ImoUpdated, () => {
            this.refreshAlarms();
            if (intervalID) {
                clearInterval(intervalID); // Stop the existing interval
            }
            intervalID = setInterval(() => this.refreshAlarms(), CACHE_TIMEOUT); 
        })

	}

	private _alarmsWithoutNotificationResponses: VoyNotification<NotificationTypes.Alarm>[] = [];
	private _alarms: VoyNotification<NotificationTypes.Alarm>[] = [];
	private _alarmOnEditOption : VoyNotification<NotificationTypes.Alarm>[] = [];

	_getAlarmList(alarms: VoyNotification<NotificationTypes.Alarm>[]) {
		// need to show only alarm notification- it should not included in do it later and no reason submitted for the alarm
		let pendingAlarms: VoyNotification<NotificationTypes.Alarm>[] = JSON.parse(
			localStorage.getItem("doItLaterAlarm") || "[]"
		);
		// filtering alarms for synchronizing data across all the systems.
        this.filterAlarmsForSynchronizing(pendingAlarms, alarms);
		pendingAlarms = JSON.parse(
			localStorage.getItem("doItLaterAlarm") || "[]"
		);
        this.handleLoadForAlerts();
		const filteredAlarms = alarms.filter((alarm, index) => {
			let alarmdata = alarm.data;
			// Checking if alarmtype is empty and also if contains valid alarmtype
			return (
				alarm.type == "Alarm" &&
                // If notification from Shore, need attention from Vessel, show alarm popup
                // If notification_responses is empty, vessel has not yet responded, so show alarm popup
				(alarm.notification_responses.length == 0 || alarm.notification_responses[0].source === "Shore") &&
				alarmdata.alarmType &&
				(Object.values(AlarmTypes).find((alarmtype:string) => alarmtype.includes(alarmdata.alarmType?.toLocaleLowerCase())))
			);
		});
		return filteredAlarms.filter((alarm) => {
			return !pendingAlarms?.some((pendingAlarm) => {
				return alarm.id == pendingAlarm.id;
			});
		});
	}

	async refreshAlarms() {
            this._alarms = await VesselNotificationsService.fetchNotifications(NotificationTypes.Alarm);
            this._alarmsWithoutNotificationResponses = this._getAlarmList(this._alarms);
            this.dispatchEvent(new Event(AlarmEvents.AlarmsUpdated));

	}

	stateReason(alarmItem: VoyNotification<NotificationTypes.Alarm>) {
		let alarmArray = [];
		alarmArray.push(alarmItem);
		this._alarmsWithoutNotificationResponses = alarmArray;
		this.dispatchEvent(new Event(AlarmEvents.AlarmsUpdated));
	}
	checkForMoreAlarms(): void {
		this.dispatchEvent(new CustomEvent(AlarmEvents.CheckMoreAlarms));
	}
	get alarms() {
		return this._alarms;
	}
	get alarmsWithoutResponses() {
		return this._alarmsWithoutNotificationResponses;
	}
    get alarmsOnEditOptions(){
		return this._alarmOnEditOption
	}
	async postAlarmsReasons(payload: AlarmPayload, notificationId: string|number) {
		const result = await VesselNotificationsService.submitAlarmReason(
			payload,
			notificationId
		);
		this.refreshAlarms()
		this._alarmOnEditOption = []
		return result;
	}


	editAlarms(alarmItem: VoyNotification<NotificationTypes.Alarm>){
		this._alarmOnEditOption = [alarmItem];
		this.dispatchEvent(new Event(AlarmEvents.AlarmsUpdated));
		this.dispatchEvent(new Event(AlarmEvents.AlarmsEdited));
	}
	openLog(){
        this.dispatchEvent(new Event("show-alarm-logs"))
    }

	// filtering alarms for synchronizing data across all the systems.
    filterAlarmsForSynchronizing(pendingAlarms: VoyNotification<NotificationTypes.Alarm>[], alarms: VoyNotification<NotificationTypes.Alarm>[]){
		let filterPendingAlarms = pendingAlarms.filter((pendingAlarm) => {
			return !alarms.some((alarm) => {
				const deadlineExceeded = new Date().getTime() - new Date(pendingAlarm.created_at).getTime() > postponeDeadline;
				console.log("deadlineExceeded", deadlineExceeded)
				return (alarm.id === pendingAlarm.id && alarm.notification_responses.length > 0) || deadlineExceeded;
			});
		});
		localStorage.setItem("doItLaterAlarm", JSON.stringify(filterPendingAlarms))
	}
	//fetch the alarm reminders from local storage and add to Alert list on page refresh
	handleLoadForAlerts() {
		let pendingAlarms: VoyNotification<NotificationTypes.Alarm>[] = JSON.parse(localStorage.getItem("doItLaterAlarm") || "[]");
    VesselAlertsModel!.removeAlertsByType((<any>window)["appenv"].vesselIMONumber, AlertType.AlarmReminder);
		if (pendingAlarms.length) {
			pendingAlarms.map((pendingAlarm) => {
				const alarm = pendingAlarm.data;
				const title = (alarm.alarmType?.toLocaleLowerCase() == AlarmTypes.Crosstrack) ? "offtrack" : alarm.alarmType;
				if (pendingAlarm.id) {
					VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
						message: getAlarmDescription(pendingAlarm).alarmDesc,
						id: pendingAlarm.id,
						title: title,
						type: AlertType.AlarmReminder,
						time: pendingAlarm.created_at
					});
				}
			})
		}
	}

	public async _fetchWeatherAlarms(type: NotificationTypes.HeavyWeather|NotificationTypes.ParametricRoll|NotificationTypes.HeavyRolling|NotificationTypes.HighAccelerationForce):Promise<WeatherAlarmNotificationData[]> {
		const weatherAlarm = await VesselNotificationsService.fetchActiveNotifications(type);
		return weatherAlarm || [];
	}

	public async getNotificationData(id: string | number): Promise<WeatherAlarmNotificationData> {
		const alertData = await VesselNotificationsService.fetchAlert(id);
		return alertData || {};
	}

	public createAndSubmitRouteNotification(payload: BestPracticeRoutePayload): void {
		// Create notification for best practice route selection
		// This notification is sent when vessel approves a plan with BPR information
		try {
			// For now, log the payload - this may need to be enhanced with actual notification creation
			console.log('Best Practice Route Notification:', payload);
			// TODO: Implement actual notification submission if backend endpoint exists
		} catch (error) {
			console.error('Error creating route notification:', error);
		}
	}
}
